export default __webpack_public_path__ + "28dbd18bfb22b154734a315d609d11eb.png";